import React from "react";
import MenuBar from "../components/menuBarLoggedIn/menuBarLoggedIn.jsx";
import Footer from "../components/footer";
import message from "../assets/images/message.png";
import "../styles/contactUs.css";
import phone from "../assets/svgs/Rose Gold.svg";
import twitter from "../assets/images/twitter.png";
import email from "../assets/svgs/emailsvg.svg";
import cell from "../assets/svgs/cell.svg";
import instagram from "../assets/images/instagram.png";
import facebook from "../assets/images/facebook.png";
import twittbtn from "../assets/images/twibtn.png";
import instabtn from "../assets/images/igbtn.png";
import facebtn from "../assets/images/facebtn.png";

const ContactUs = () => {
  return (
    <div>
      <MenuBar />
      <main className="contact-main">
        <div className="mainContent">
          <article>
            <p className="stranger">Dont be a stranger.</p>
            <h3>
              Let's connect and solve your problem Your feedback matters to us
            </h3>
            <p>
              Our goal is to provide you with the best travel experience
              possible let us know how we can help
            </p>
            <button className="contact-mail">
              {" "}
              <img src={email} alt="" className="email-img" />{" "}
              hello@shutle9ja.com
            </button>
            <button className="contact-line">
              {" "}
              <img src={cell} alt="" className="cell-img" /> +2349045263525
            </button>
          </article>
          <div className="images">
            <img src={message} alt="" className="msg-img" />
            <img src={message} alt="" className="msg-img2" />
          </div>
        </div>
      </main>

      <section className="Enquiries">
        <span>
          <h3>Do you have further enquiries?</h3>
          <p>
            We curated our FAQs to answer common questions, but if they didn't
            address <br /> our specific concern we're here to help.
          </p>
        </span>
        <div className="contact-form">
          <form action="">
            <label htmlFor="">Name</label>
            <input
              type="text"
              className="name-input"
              placeholder="Enter your full name"
            />

            <label htmlFor="">Email address</label>
            <input
              type="email"
              className="email-input"
              placeholder="Enter your email address"
            />

            <label htmlFor="">Description</label>
            <textarea
              name="description"
              id=""
              cols="30"
              rows="10"
              placeholder="Enter your message...."
              className="desc-input"
            ></textarea>

            <button type="submit" className="talk">
              Let's Talk
            </button>
          </form>
        </div>
      </section>

      <section className="social">
        <h3>
          Stay connected to us on <span>social media</span>
        </h3>

        <div className="social-wrapper">
          <ul className="social-list">
            <li>
              <a href="" className="handles">
                {" "}
                <img src={twitter} alt="" className="twitt-img" />
                Twitter.com/shuttle9ja
              </a>
            </li>
            <li>
              <a href="" className="handles">
                <img src={instagram} alt="" className="insta-img" />
                Instagram.com/shuttle9ja
              </a>
            </li>
            <li>
              <a href="" className="handles">
                <img src={facebook} alt="" className="face-img" />
                Facebook.com/shuttle9ja
              </a>
            </li>
          </ul>
          <div className="phone">
            <img src={phone} alt="" className="display" />
           
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ContactUs;
